export type Translator = (text: string, ...args: Array<string | number>) => string;

const format = (template: string, args: Array<string | number>): string => {
    let result = template;
    for (const arg of args) {
        result = result.replace('%s', String(arg));
    }
    return result;
};

function toUnicodeEscape(str: string): string {
    return str.replace(/[^\x00-\x7F]/g, (char) => {
      // Pobierz kod znaku, zamień na hex, dodaj padding zerami
      return "\\u" + ("0000" + char.charCodeAt(0).toString(16)).slice(-4);
    });
}

export async function initTranslations(scope: string, apiUrl: string): Promise<Translator> {
    const baseUrl = apiUrl.replace(/\/$/, '');

    try {
        const response = await fetch(`${baseUrl}/i18n/${scope}`, {credentials: 'include'});
        const data = await response.json();
        const messages: Record<string, string> = data.messages || {};

        const translator: Translator = (text, ...args) => {
            const encodedKey = toUnicodeEscape(text);
            console.log(text, encodedKey);
            const template = messages[encodedKey] ?? messages[text] ?? text;
            return format(template, args);
        };

        (window as any).__ = translator;
        return translator;
    } catch (e) {
        const fallback: Translator = (text, ...args) => format(text, args);
        (window as any).__ = fallback;
        return fallback;
    }
}
